import {Box, Card, Tab, Tabs} from "@mui/material";
import a11yProps from "../../helpers/ay-props";
import React, {useEffect} from "react";
import TabPanel from "../../helpers/TabPanel";
import RecruitManagement from "./RecruitManagement";
import {connect} from "react-redux";
import {mapDispatchToProps} from "../../store/helpers/mapDispatch";
import moment from "moment";
import RecruitPassedResults from "./RecruitPassedResults";

function Recruitment(props) {
    const {SetSelectedMenu} = props
    const [tabValue, setTabValue] = React.useState(0);
    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    };

    useEffect(() => {
        SetSelectedMenu({
            menu: "recruitment",
            title: "Recruit Management"
        })
    }, []);

    return <div>
        <Card>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={tabValue} onChange={handleChange} aria-label="basic tabs example">
                    <Tab label="Applicants" {...a11yProps(0)} />
                    <Tab label="Recommended" {...a11yProps(1)} />
                    <Tab label="Highly Recommended" {...a11yProps(2)} />
                    <Tab label="Not Considered" {...a11yProps(3)} />
                    <Tab label="Passed Exams" {...a11yProps(4)} />
                    <Tab label="Candidate Pool" {...a11yProps(5)} />
                </Tabs>
            </Box>
            <TabPanel index={0} value={tabValue} p={0}>
                <RecruitManagement {...props} fileName={`new-applicants-${moment().format("YYYY-MM-DD")}`}/>
            </TabPanel>
            <TabPanel index={1} value={tabValue} p={0}>
                <RecruitManagement {...props} rating={1} fileName={`recommended-applicants-${moment().format("YYYY-MM-DD")}`}/>
            </TabPanel>
            <TabPanel index={2} value={tabValue} p={0}>
                <RecruitManagement {...props} rating={2} fileName={`highly-recommended-applicants-${moment().format("YYYY-MM-DD")}`}/>
            </TabPanel>
            <TabPanel index={3} value={tabValue} p={0}>
                <RecruitManagement {...props} rating={-1} fileName={`not-considered-recommended-applicants-${moment().format("YYYY-MM-DD")}`}/>
            </TabPanel>
            <TabPanel index={4} value={tabValue} p={0}>
                <RecruitPassedResults {...props} rating={-1} fileName={`passed-exams-applicants-${moment().format("YYYY-MM-DD")}`}/>
            </TabPanel>
            <TabPanel index={5} value={tabValue} p={0}>
                <RecruitPassedResults pageStatus={"candidate"} {...props} fileName={`candidate-pool-${moment().format("YYYY-MM-DD")}`}/>
            </TabPanel>
        </Card>
    </div>
}

export default connect(null,mapDispatchToProps)(Recruitment);
